<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="@/assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="@/assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="wordset">
                                <ul>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                                                src="@/assets/img/icons/pdf.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                                                src="@/assets/img/icons/excel.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                                                src="@/assets/img/icons/printer.svg" alt="img" /></a>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                        <!-- /Filter -->
                        <!-- <div class="card mb-0" id="filter_inputs" :style="{
                            display: filter ? 'block' : 'none',
                        }">
                            <div class="card-body pb-0">
                                <div class="row">
                                    <div class="col-lg-12 col-sm-12">
                                        <div class="row">
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Product" placeholder="Choose Product" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Choose" placeholder="Choose Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Category" placeholder="Choose Sub Category" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Brand" placeholder="Brand" />
                                                </div>
                                            </div>
                                            <div class="col-lg col-sm-6 col-12">
                                                <div class="form-group">
                                                    <vue-select :options="Price" placeholder="Price" />
                                                </div>
                                            </div>
                                            <div class="col-lg-1 col-sm-6 col-12">
                                                <div class="form-group">
                                                    <a class="btn btn-filters ms-auto"><img
                                                            src="@/assets/img/icons/search-whites.svg" alt="img" /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <!-- /Filter -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="filteredData" @change="handleTableChange" :pagination="pagination" :loading="loading">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    <!-- <template v-if="column.key === 'deskripsi'">
                                        <div class="productimgname">
                                            {{ shortenDescription(record.deskripsi) }}
                                        </div>


                                    </template> -->
                                    <template v-if="column.key === 'lampiran'">
                                        <div class="productimgname" v-if="record.lampiran != ''">
                                            <a :href="record.lampiran" class="product-img">
                                                <vue-feather type="file"></vue-feather>
                                            </a>

                                        </div>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3" @click="show_izitoast">
                                            <img src="@/assets/img/icons/eye.svg" alt="img" />
                                        </a> -->
                                        <router-link class="me-3" to="editnews" @click="edit(record);">
                                            <img src="@/assets/img/icons/edit.svg" alt="img" />
                                        </router-link>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Data</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this data?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, } from "@/assets/js/function";
import { watch } from 'vue';

export default {
    data() {
        return {
            filter: false,
            title: "News & Event List",
            title1: "manage news and events",
            items: [
                {
                    text: "Add New ",
                    addname: "/addnews",
                },
            ],

            //data
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Title",
                    dataIndex: "judul",
                    key: "judul",
                    sorter: {
                        compare: (a, b) => {
                            a = a.judul.toLowerCase();
                            b = b.judul.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                // {
                //     title: "Description",
                //     dataIndex: "deskripsi",
                //     key: "deskripsi",
                //     sorter: {
                //         compare: (a, b) => {
                //             a = a.deskripsi.toLowerCase();
                //             b = b.deskripsi.toLowerCase();
                //             return a > b ? -1 : b > a ? 1 : 0;
                //         },
                //     },
                // },
                {
                    title: "Type",
                    dataIndex: "tipe",
                    key: "tipe",
                    sorter: {
                        compare: (a, b) => {
                            a = a.tipe.toLowerCase();
                            b = b.tipe.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Date Event",
                    dataIndex: "tanggal",
                    key: "tanggal",
                    sorter: {
                        compare: (a, b) => {
                            a = a.tanggal.toLowerCase();
                            b = b.tanggal.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                // {
                //     title: "Directed to",
                //     dataIndex: "ditujukan_kepada",
                //     key: "ditujukan_kepada",
                //     sorter: {
                //         compare: (a, b) => {
                //             a = a.ditujukan_kepada.toLowerCase();
                //             b = b.ditujukan_kepada.toLowerCase();
                //             return a > b ? -1 : b > a ? 1 : 0;
                //         },
                //     },
                // },
                // {
                //     title: "Employee Name",
                //     dataIndex: "nama_employee",
                //     key: "nama_employee",
                //     sorter: {
                //         compare: (a, b) => {
                //             a = a.nama_employee.toLowerCase();
                //             b = b.nama_employee.toLowerCase();
                //             return a > b ? -1 : b > a ? 1 : 0;
                //         },
                //     },
                // },

                // {
                //     title: "Location",
                //     dataIndex: "nama_lokasi",
                //     key: "nama_lokasi",
                //     sorter: {
                //         compare: (a, b) => {
                //             a = a.nama_lokasi.toLowerCase();
                //             b = b.nama_lokasi.toLowerCase();
                //             return a > b ? -1 : b > a ? 1 : 0;
                //         },
                //     },
                // },
                {
                    title: "Lampiran",
                    dataIndex: "lampiran",
                    key: "lampiran",
                    sorter: {
                        compare: (a, b) => {
                            a = a.lampiran.toLowerCase();
                            b = b.lampiran.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                },
            ],

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            loading: false,

            //filter
            query: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')
        
        this.index();
    },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {

                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison

            return this.data.filter(item =>
                item.judul.toLowerCase().includes(lowerCaseQuery) ||
                item.deskripsi.toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {
       
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },


        shortenDescription(description) {
            if (description.length > 35) {
                return description.substring(0, 35) + '...';
            } else {
                return description;
            }
        },

        async index() {
            this.loading = true;
            
            let formData = new FormData();
            appendForm(formData);

            const api = base_url + '/v3/news/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const news = data.data.data_news;
            console.log('ini data payroll:', data)
            
            if(data.status){
                this.data = [];

                news.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

                this.loading = false;

                //save shift to local
                localStorage.setItem('lokasiList', JSON.stringify(data.data.data_lokasi_branch));
                localStorage.setItem('employeeList', JSON.stringify(data.data.data_employees));
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
        },

        async delete2() {
            
            let formData = new FormData();
            appendForm(formData)

            formData.append("id", this.id_terminate);
            // formData.append("nama", this.nama_terminate);


            // for (let [key, value] of formData.entries()) {
            //     console.log(`${key}: ${value}`);
            // }

            const api = base_url + '/v3/news/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
           
            
            if(data.status){
                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                this.data.splice(index, 1);
                AlertBottom(data.message);
                this.hideModal2('terminate');
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           


        },
        terminate(id, nama) {
            this.id_terminate = id;
            this.nama_terminate = nama;
            this.tanggal_terminate = new Date();
        }
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
</style>